<template>
    <el-form-item class="w-100" :label="label" label-position="top" :prop="prop">
        <el-input
            type="textarea"
            v-model="localInput"
            size="large"
            :placeholder="placeholder"
            :autosize="autosize"
            :maxlength="maxlength"
            :show-word-limit="showWordLimit"
            :disabled="disabled"
            @input="updateValue"
        >
            <template #prefix>
                <i :class="'ti ti-' + icon"></i>
            </template>
        </el-input>
    </el-form-item>
</template>

<script lang="ts" setup>
    import { ref, watch } from 'vue'

    const props = defineProps({
        modelValue: {
            type: [String, Number, null],
            default: null,
        },
        prop: {
            type: String,
        },
        placeholder: {
            type: String,
            default: '',
        },
        icon: {
            type: String,
            default: 'pencil',
        },
        label: {
            type: String,
            default: '',
        },
        autosize: {
            type: [Boolean, Object],
            default: false,
        },
        maxlength: {
            type: [Number, String],
            default: undefined,
        },
        showWordLimit: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    })

    const emit = defineEmits(['update:modelValue'])

    const localInput = ref(props.modelValue)

    watch(
        () => props.modelValue,
        newValue => {
            localInput.value = newValue
        },
    )

    const updateValue = (value: string) => {
        localInput.value = value
        emit('update:modelValue', value)
    }
</script>
